import app from "../components/app";
import data from "../components/quiz.json";
import { useEffect, useState } from "react";


export default function Quiz(props) {
    useEffect(() => {
        document.querySelectorAll(".question input").forEach(function(v){
            v.addEventListener("input", function(){
                const value = v.value.trim();
                v.parentElement.classList.remove("right");
                v.parentElement.classList.remove("wrong");
                if(value !== "") {
                    if(v.parentElement.getAttribute("data-answer") === value) {
                        v.parentElement.classList.add("right");
                    }
                    else {
                        v.parentElement.classList.add("wrong");
                    }
                }
                
            })
        })
    }, []);

    const style = `
    .container.quiz input {
        font-size: 36px;
        border: 0;
        border-bottom: dashed 3px #000;
        width: 250px;
        outline: 0;
        text-align: center;
    }

    .container.quiz input:focus {
        background: #f1f1f1;
    }
    .container.quiz span.right input {
        background: #e7ffb1;
    }
    .container.quiz span.wrong input {
        background: #ffb09c;
    }
    
    `
    return <div className="w-100 h-100 overflow-scroll">
        <div className="container p-5 mt-5 mb-5 m-auto border rounded-3 border-1">
        <input id="imageText" className="form-control form-control-lg mb-3" type="text" placeholder="Search Image" />

        <button type="button" className="btn btn-primary btn-lg" onClick={function(){
             app.imageGeneration({
                //"method":"getTopImage",
                "method":"getTopImages",
                "text":document.querySelector("#imageText").value.trim()
            }).then(function(a){
                console.log(a);
            })
        }}>Search Top 10 Image</button>

<button type="button" className="btn btn-primary btn-lg ms-2 me-2" onClick={function(){
             app.imageGeneration({
                "method":"getTopImage",
                //"method":"getTopImages",
                "text":document.querySelector("#imageText").value.trim()
            }).then(function(a){
                console.log(a);
            })
        }}>Search Top Most Image</button>


        <button className="d-none" onClick={function(){
         app.imageGeneration({
             "method":"generateImage",
             "category":"foodcourt",
             "text":"Jumping Monkey"
         }).then(function(a){
             console.log(a);
         })
     }}>Image Code</button>
        </div>
           
        <style>
{style}
        </style>
       <div className="container quiz">
       <h1>{data.listData.quizName}</h1>
       <p className="text-center">
           {
               data.listData.questions.map(function(v){
                    return v.answers.map(function(v){
                        return  <b className="border border-2 border-secondary rounded-pill p-2 m-1 fs-4">{v.ans_name}</b>
                        
                    })
               })
           }
      

       </p>
        <div className="p-3">
        {
            data.listData.questions.map(function(v){
                let answer = "";
                v.answers.forEach(function(val){
                    if(val.is_answer_correct) {
                        answer = val.ans_name;
                    }
                });
                
                return <h2 className="p-2 question" dangerouslySetInnerHTML={{__html:v.ques_name.replace("__ANSWER__", `<span data-answer="${answer}" class="position-relative"><input type="text" /></span>`)}} />
            })
        }
        </div>
       </div>
    </div>
}